export const TEXTURE_ATLAS_TEXTURE_WIDTH = 1024;
export const TEXTURE_ATLAS_CAPACITY = 43;
